module.exports = __webpack_public_path__ + "img/academy-white.4aa65c9.svg";